module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b99c7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/faicon.vue
// module id = 665
// module chunks = 85